import { render, staticRenderFns } from "./veStuAssocMyInfo.vue?vue&type=template&id=12991b8e&scoped=true"
import script from "./veStuAssocMyInfo.vue?vue&type=script&lang=js"
export * from "./veStuAssocMyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12991b8e",
  null
  
)

export default component.exports